import { createFileRoute, redirect } from "@tanstack/react-router";

import { authClient } from "~/lib/auth";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const session = await authClient.getSession();
    const isAuthenticated = !!session?.data?.user;

    throw redirect({
      to: isAuthenticated ? "/dashboard" : "/inloggen",
    });
  },
});
